// class TestimonialsModelerSlider {
//   constructor(section) {
//     this.section = section;
//     this.slider = section.querySelector('.testimonials-modeler-slider');
//     this.dots = section.querySelectorAll('.testimonials-modeler-dot');
//     this.cards = section.querySelectorAll('.testimonial-modeler-card');
//     this.currentIndex = 0;
    
//     if (!this.slider || this.dots.length === 0) return;
    
//     this.init();
//   }

//   init() {
//     // Set initial active dot
//     this.updateDots(0);
    
//     // Dot click handlers
//     this.dots.forEach((dot, index) => {
//       dot.addEventListener('click', () => {
//         this.goToSlide(index);
//       });
//     });

//     // Scroll event to update active dot
//     let scrollTimeout;
//     this.slider.addEventListener('scroll', () => {
//       clearTimeout(scrollTimeout);
//       scrollTimeout = setTimeout(() => {
//         this.updateActiveDot();
//       }, 150);
//     });

//     // Make slider focusable for keyboard navigation
//     this.slider.setAttribute('tabindex', '0');
    
//     // Keyboard navigation
//     this.slider.addEventListener('keydown', (e) => {
//       if (e.key === 'ArrowLeft') {
//         e.preventDefault();
//         this.goToPrevious();
//       } else if (e.key === 'ArrowRight') {
//         e.preventDefault();
//         this.goToNext();
//       }
//     });

//     // Handle window resize
//     let resizeTimeout;
//     window.addEventListener('resize', () => {
//       clearTimeout(resizeTimeout);
//       resizeTimeout = setTimeout(() => {
//         this.goToSlide(this.currentIndex);
//       }, 200);
//     });
//   }

//   goToSlide(index) {
//     if (index < 0 || index >= this.dots.length) return;
    
//     const slideWidth = this.slider.offsetWidth;
//     this.slider.scrollTo({
//       left: slideWidth * index,
//       behavior: 'smooth'
//     });
//     this.currentIndex = index;
//     this.updateDots(index);
//   }

//   goToNext() {
//     const totalSlides = this.dots.length;
//     const nextIndex = (this.currentIndex + 1) % totalSlides;
//     this.goToSlide(nextIndex);
//   }

//   goToPrevious() {
//     const totalSlides = this.dots.length;
//     const prevIndex = (this.currentIndex - 1 + totalSlides) % totalSlides;
//     this.goToSlide(prevIndex);
//   }

//   updateActiveDot() {
//     const slideWidth = this.slider.offsetWidth;
//     const scrollLeft = this.slider.scrollLeft;
//     const newIndex = Math.round(scrollLeft / slideWidth);
    
//     if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.dots.length) {
//       this.currentIndex = newIndex;
//       this.updateDots(newIndex);
//     }
//   }

//   updateDots(index) {
//     this.dots.forEach((dot, i) => {
//       if (i === index) {
//         dot.classList.add('active');
//         dot.setAttribute('aria-current', 'true');
//         dot.setAttribute('aria-label', `Slide ${i + 1} of ${this.dots.length} (active)`);
//       } else {
//         dot.classList.remove('active');
//         dot.setAttribute('aria-current', 'false');
//         dot.setAttribute('aria-label', `Go to slide ${i + 1} of ${this.dots.length}`);
//       }
//     });
//   }
// }

// // Initialize all testimonial sliders on the page
// document.addEventListener('DOMContentLoaded', () => {
//   const sections = document.querySelectorAll('.testimonials-modeler-section');
//   sections.forEach(section => {
//     new TestimonialsModelerSlider(section);
//   });
// });

// // Shopify theme editor support
// if (window.Shopify && window.Shopify.designMode) {
//   document.addEventListener('shopify:section:load', (event) => {
//     const section = event.target.querySelector('.testimonials-modeler-section') || event.target;
//     if (section.classList.contains('testimonials-modeler-section')) {
//       new TestimonialsModelerSlider(section);
//     }
//   });
// }

class TestimonialsModelerSlider {
  constructor(section) {
    this.section = section;
    this.slider = section.querySelector('.testimonials-modeler-slider');
    this.dots = section.querySelectorAll('.testimonials-modeler-dot');
    this.cards = section.querySelectorAll('.testimonial-modeler-card');
    this.currentIndex = 0;

    // Drag state
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;

    if (!this.slider || this.dots.length === 0) return;

    this.init();
  }

  init() {
    this.updateDots(0);

    /* --------------------
       DOT NAVIGATION
    -------------------- */
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goToSlide(index);
      });
    });

    /* --------------------
       SCROLL → DOT SYNC
    -------------------- */
    let scrollTimeout;
    this.slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        this.updateActiveDot();
      }, 120);
    });

    /* --------------------
       KEYBOARD SUPPORT
    -------------------- */
    this.slider.setAttribute('tabindex', '0');

    this.slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.goToPrevious();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.goToNext();
      }
    });

    /* --------------------
       DRAG / GRAB SUPPORT
    -------------------- */
    this.slider.addEventListener('mousedown', (e) => {
      this.isDown = true;
      this.slider.classList.add('is-dragging');
      this.startX = e.pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
    });

    this.slider.addEventListener('mouseleave', () => {
      this.isDown = false;
      this.slider.classList.remove('is-dragging');
    });

    this.slider.addEventListener('mouseup', () => {
      this.isDown = false;
      this.slider.classList.remove('is-dragging');
    });

    this.slider.addEventListener('mousemove', (e) => {
      if (!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - this.startX) * 1.2; // drag sensitivity
      this.slider.scrollLeft = this.scrollLeft - walk;
    });

    /* --------------------
       RESIZE HANDLING
    -------------------- */
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.goToSlide(this.currentIndex);
      }, 200);
    });
  }

  goToSlide(index) {
    if (index < 0 || index >= this.dots.length) return;

    const slideWidth = this.slider.offsetWidth;
    this.slider.scrollTo({
      left: slideWidth * index,
      behavior: 'smooth'
    });

    this.currentIndex = index;
    this.updateDots(index);
  }

  goToNext() {
    this.goToSlide((this.currentIndex + 1) % this.dots.length);
  }

  goToPrevious() {
    this.goToSlide((this.currentIndex - 1 + this.dots.length) % this.dots.length);
  }

  updateActiveDot() {
    const slideWidth = this.slider.offsetWidth;
    const newIndex = Math.round(this.slider.scrollLeft / slideWidth);

    if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.dots.length) {
      this.currentIndex = newIndex;
      this.updateDots(newIndex);
    }
  }

  updateDots(index) {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }
}

/* --------------------
   INIT
-------------------- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.testimonials-modeler-section')
    .forEach(section => new TestimonialsModelerSlider(section));
});

/* --------------------
   SHOPIFY EDITOR SUPPORT
-------------------- */
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.testimonials-modeler-section') || event.target;
    if (section.classList.contains('testimonials-modeler-section')) {
      new TestimonialsModelerSlider(section);
    }
  });
}
